module.exports = __webpack_public_path__ + "img/introduceList5.3cb160db.jpg";